import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

import { ConfigViewPillar, Metric } from './config.insight.model';
import { CustomizeColumnsInsightChangeEvent } from './customize-columns.insight.model';
import {
    CustomizeMetricsInsightCanSelectFn,
    CustomizeMetricsInsightChangeEvent,
} from './customize-metrics.insight.model';
import {
    CustomizePillarsInsightCanSelectFn,
    CustomizePillarsInsightChangeEvent,
} from './customize-pillars.insight.model';
import { TranslationKeyMap } from './insight.i18n';
import { MetricPath } from './insight.state';
import { OptionalColumn } from './optional-column.insight.model';

@Component({
    selector: '[cmpsInsightCustomize]',
    templateUrl: './customize.insight.component.html',
})
export class CustomizeInsightComponent implements OnChanges, OnInit, OnDestroy {
    @Input() pillars: boolean;
    @Input() pillarsPillars: ConfigViewPillar[];
    @Input() pillarsSelection: ConfigViewPillar[];
    @Output()
    pillarsSelectionChange: EventEmitter<CustomizePillarsInsightChangeEvent>;

    @Input() pillarsCanSelect: CustomizePillarsInsightCanSelectFn;
    @Input() columns: boolean;
    @Input() columnsColumns: OptionalColumn[];
    @Input() columnsSelection: OptionalColumn[];
    @Output()
    columnsSelectionChange: EventEmitter<CustomizeColumnsInsightChangeEvent>;

    @Input() metrics: boolean;
    @Input() metricsMetrics: Metric[];
    @Input() metricsPillars: ConfigViewPillar[];
    @Input() metricsSelection: MetricPath[];
    @Output()
    metricsSelectionChange: EventEmitter<CustomizeMetricsInsightChangeEvent>;

    @Input() metricsCanSelect: CustomizeMetricsInsightCanSelectFn;

    /** @private */ _i18n = TranslationKeyMap;

    _count: number;

    localState: {};

    constructor() {
        this.pillarsSelectionChange = new EventEmitter();
        this.columnsSelectionChange = new EventEmitter();
        this.metricsSelectionChange = new EventEmitter();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.pillars != null ||
            changes.pillarsPillars != null ||
            changes.pillarsSelection != null ||
            changes.pillarsCanSelect != null ||
            changes.colums != null ||
            changes.columnsColumns != null ||
            changes.columnsSelection != null ||
            changes.metrics != null ||
            changes.metricsMetrics != null ||
            changes.metricsPillars != null ||
            changes.metricsSelection != null
        ) {
            this._setValues();
        }
    }

    ngOnInit(): void {
        this._setValues();
    }

    ngOnDestroy(): void {
        this.pillarsSelectionChange.complete();
        this.columnsSelectionChange.complete();
        this.metricsSelectionChange.complete();
    }

    private _setValues(): void {
        let count = 0;
        if (this.pillars) count++;
        if (this.columns) count++;
        if (this.metrics) count++;
        this._count = count;
    }
}
